import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import {
  greetingTopSpacing,
  plannerItemTypeHeightMap,
  dayTitleLeftSpacing
} from '../planner-constants';
import useGreetingTimer from '../planner-hooks/useGreetingTimer';

const Wrapper = styled.div`
  height: ${({ $height }) => $height}px;
  padding-top: ${greetingTopSpacing}px;
`;

const ContentWrapper = styled.div`
  margin-left: ${dayTitleLeftSpacing};
  padding: 0 ${Spacings.SPACING_8B};
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 1;
  box-shadow: ${boxShadowGenerator()};
  > * {
    position: relative;
  }
`;

const ImageContainer = styled.div`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Title = styled(H6)`
  line-height: 129%;
`;

const Info = styled(P2)`
  line-height: 133%;
  margin-top: ${Spacings.SPACING_2};
`;

const GreetingCard = ({ metaItem, eventsCount }) => {
  const { plannerItemType } = metaItem;
  const { imgSrc, imgAlt, title, info, color } = useGreetingTimer(eventsCount);
  const height = plannerItemTypeHeightMap[plannerItemType];
  return (
    <Wrapper $height={height}>
      <ContentWrapper>
        <ImageContainer>
          <Image
            src={imgSrc}
            alt={imgAlt}
            width={436}
            height={height - greetingTopSpacing}
            loading="eager"
          />
        </ImageContainer>
        <Title color={color}>{title}</Title>
        {info && <Info color={color}>{info}</Info>}
      </ContentWrapper>
    </Wrapper>
  );
};

export default GreetingCard;
